import React from 'react';
import { Button } from '@material-ui/core';
import { Link, Outlet } from 'react-router-dom';
import { useIntl } from 'react-intl'; 
interface IButtonLinkProps {
  className?: string;
  text: string;
  to: string;
  icon?: React.ReactElement;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
}
export const ButtonLink = (props: IButtonLinkProps) => {
  const { formatMessage } = useIntl();
  const { className, text, to, icon, variant, disabled } = props;
  return (<>
    <Button
      disabled={disabled}
      className={className}
      variant={variant || 'outlined'}
      component={Link}
      to={to}
      startIcon={icon}
    >
      {formatMessage({ id:text})}
    </Button>
      <Outlet/>
  </>
  );
};